import React from 'react';
import styled from 'styled-components/macro';

export const Wrapper = styled.svg`
  aspect-ratio: 1/1;
  height: 100%;
  width: 12rem;

  cursor: pointer;
`;

const Circle = styled.circle(({ $active }: { $active: boolean }) => `
  transform: scale(${$active ? "0.8" : "0"});
  transform-origin: center;
  transition: 0.25s;
`);

const RadioButton = ({ color = "black", active, onClick }: {
  color?: string,
  active: boolean,
  onClick?: () => void
}) => (
  <Wrapper
    width={949} height={949}
    viewBox="0 0 949 949"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fill="black"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M474.5 949C736.559 949 949 736.56 949 474.5C949 212.44 736.559 0 474.5 0C212.441 0 0 212.44 0 474.5C0 736.56 212.441 949 474.5 
        949ZM475 895C707.512 895 896 706.512 896 474C896 241.488 707.512 53 475 53C242.488 53 54 241.488 54 474C54 706.512 242.488 895 
        475 895Z"
    />

    <Circle
      fill={color}
      cx="474.5" cy="474.5"
      r="309.5"
      $active={active}
    />
  </Wrapper>
);

export default RadioButton;